<div class="about-container bg-gray-50 min-h-screen">
  <!-- Hero Section -->
  <section class="relative bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-12 sm:py-20 lg:py-24">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h1 class="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">About IMMOVÉA Real Estate</h1>
      <p class="text-xl sm:text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed">Your trusted partner in finding your dream home and making smart real estate investments</p>
    </div>
  </section>

  <!-- Our Story Section -->
  <section class="py-20 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-4xl sm:text-5xl font-bold text-gray-900 mb-12 text-center">Our Story</h2>
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div class="space-y-6">
          <p class="text-lg text-gray-600 leading-relaxed">
            IMMOVÉA Real Estate was founded with a simple mission: to revolutionize the real estate experience by providing exceptional service, transparency, and expertise. With over two decades of combined experience in the industry, our team understands the complexities of property transactions and is committed to making the process seamless for every client.
          </p>
          <p class="text-lg text-gray-600 leading-relaxed">
            Whether you're a first-time homebuyer, an experienced investor, or someone looking to sell your property, we bring dedication and professionalism to every transaction. Our success is measured by the satisfaction of our clients and the lasting relationships we build.
          </p>
        </div>
        <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 sm:p-10 shadow-lg">
          <h3 class="text-3xl font-bold text-gray-900 mb-8">By The Numbers</h3>
          <div class="space-y-6">
            <div class="flex items-center">
              <div class="text-4xl sm:text-5xl font-bold text-immovea-navy mr-6">500+</div>
              <p class="text-lg text-gray-700">Properties Successfully Sold</p>
            </div>
            <div class="flex items-center">
              <div class="text-4xl sm:text-5xl font-bold text-immovea-navy mr-6">1000+</div>
              <p class="text-lg text-gray-700">Satisfied Clients</p>
            </div>
            <div class="flex items-center">
              <div class="text-4xl sm:text-5xl font-bold text-immovea-navy mr-6">20+</div>
              <p class="text-lg text-gray-700">Years of Experience</p>
            </div>
            <div class="flex items-center">
              <div class="text-4xl sm:text-5xl font-bold text-immovea-navy mr-6">50+</div>
              <p class="text-lg text-gray-700">Professional Team Members</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section -->
  <section class="py-20 bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-4xl sm:text-5xl font-bold text-gray-900 mb-4 text-center">Why Choose IMMOVÉA?</h2>
      <p class="text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto">We combine expertise, technology, and personal service to deliver exceptional results</p>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div class="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-immovea-navy">
          <div class="w-14 h-14 bg-gradient-to-br from-immovea-navy to-blue-700 rounded-xl flex items-center justify-center mb-4">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
            </svg>
          </div>
          <h4 class="text-2xl font-semibold text-gray-900 mb-3">Expert Agents</h4>
          <p class="text-gray-600 leading-relaxed">Our experienced team of licensed professionals has extensive knowledge of local markets and property valuations.</p>
        </div>
        <div class="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-emerald-500">
          <div class="w-14 h-14 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center mb-4">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <h4 class="text-2xl font-semibold text-gray-900 mb-3">Competitive Pricing</h4>
          <p class="text-gray-600 leading-relaxed">We leverage market insights to ensure you get the best value for your money, whether buying or selling.</p>
        </div>
        <div class="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-yellow-500">
          <div class="w-14 h-14 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl flex items-center justify-center mb-4">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
            </svg>
          </div>
          <h4 class="text-2xl font-semibold text-gray-900 mb-3">Efficient Service</h4>
          <p class="text-gray-600 leading-relaxed">Quick processing and smooth transactions from initial consultation to closing, saving you time and stress.</p>
        </div>
        <div class="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-purple-500">
          <div class="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center mb-4">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
            </svg>
          </div>
          <h4 class="text-2xl font-semibold text-gray-900 mb-3">Transparent Process</h4>
          <p class="text-gray-600 leading-relaxed">Full transparency throughout the entire process with regular updates and clear communication.</p>
        </div>
        <div class="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-pink-500">
          <div class="w-14 h-14 bg-gradient-to-br from-pink-500 to-pink-600 rounded-xl flex items-center justify-center mb-4">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path>
            </svg>
          </div>
          <h4 class="text-2xl font-semibold text-gray-900 mb-3">Personalized Service</h4>
          <p class="text-gray-600 leading-relaxed">We tailor our services to meet your unique needs and goals, treating every client with individual attention.</p>
        </div>
        <div class="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-l-4 border-indigo-500">
          <div class="w-14 h-14 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center mb-4">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
            </svg>
          </div>
          <h4 class="text-2xl font-semibold text-gray-900 mb-3">Long-term Support</h4>
          <p class="text-gray-600 leading-relaxed">Our relationship doesn't end at closing. We provide ongoing support and resources for all our clients.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Our Services Section -->
  <section class="py-20 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-4xl sm:text-5xl font-bold text-gray-900 mb-4 text-center">Our Services</h2>
      <p class="text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto">Comprehensive real estate solutions tailored to your needs</p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 shadow-lg">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 bg-immovea-navy rounded-xl flex items-center justify-center mr-4">
              <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </div>
            <h3 class="text-2xl font-semibold text-immovea-navy">For Buyers</h3>
          </div>
          <ul class="space-y-4 text-gray-700">
            <li class="flex items-start">
              <svg class="w-6 h-6 text-immovea-navy mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Property search and evaluation</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-immovea-navy mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Mortgage pre-approval guidance</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-immovea-navy mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Negotiation and offer management</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-immovea-navy mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Home inspection coordination</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-immovea-navy mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Closing assistance and title review</span>
            </li>
          </ul>
        </div>
        <div class="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-8 shadow-lg">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 bg-emerald-600 rounded-xl flex items-center justify-center mr-4">
              <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
              </svg>
            </div>
            <h3 class="text-2xl font-semibold text-emerald-700">For Sellers</h3>
          </div>
          <ul class="space-y-4 text-gray-700">
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Comparative market analysis</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Property staging and marketing</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Professional photography and listings</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Buyer showings and open houses</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Negotiation and contract management</span>
            </li>
          </ul>
        </div>
        <div class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 shadow-lg">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center mr-4">
              <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <h3 class="text-2xl font-semibold text-purple-700">For Investors</h3>
          </div>
          <ul class="space-y-4 text-gray-700">
            <li class="flex items-start">
              <svg class="w-6 h-6 text-purple-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Investment property analysis</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-purple-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">ROI calculations and market trends</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-purple-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Portfolio management support</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-purple-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Rental property guidance</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-purple-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Off-market deals and opportunities</span>
            </li>
          </ul>
        </div>
        <div class="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 shadow-lg">
          <div class="flex items-center mb-6">
            <div class="w-12 h-12 bg-orange-600 rounded-xl flex items-center justify-center mr-4">
              <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
              </svg>
            </div>
            <h3 class="text-2xl font-semibold text-orange-700">Additional Services</h3>
          </div>
          <ul class="space-y-4 text-gray-700">
            <li class="flex items-start">
              <svg class="w-6 h-6 text-orange-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Property management consultation</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-orange-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Relocation assistance</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-orange-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Market analysis and reports</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-orange-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">Legal and tax coordination</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-orange-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-lg">24/7 client support</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- Mission Statement Section -->
  <section class="py-20 bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-4xl sm:text-5xl font-bold mb-12 text-center">Our Mission & Values</h2>
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div class="bg-white/10 backdrop-blur rounded-2xl p-8 sm:p-10">
          <h3 class="text-3xl font-semibold mb-6">Our Mission</h3>
          <p class="text-blue-100 text-lg leading-relaxed">
            To empower individuals and families in their real estate journey by providing expert guidance, transparent communication, and exceptional service. We strive to build lasting relationships built on trust, integrity, and a genuine commitment to our clients' success.
          </p>
        </div>
        <div class="bg-white/10 backdrop-blur rounded-2xl p-8 sm:p-10">
          <h3 class="text-3xl font-semibold mb-6">Our Core Values</h3>
          <ul class="space-y-4 text-blue-100 text-lg">
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-400 mr-3 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span><strong class="text-white">Integrity:</strong> Honest and transparent in all dealings</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-400 mr-3 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span><strong class="text-white">Excellence:</strong> Delivering superior service every day</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-400 mr-3 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span><strong class="text-white">Client-First:</strong> Your goals are our priorities</span>
            </li>
            <li class="flex items-start">
              <svg class="w-6 h-6 text-emerald-400 mr-3 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span><strong class="text-white">Innovation:</strong> Using technology to improve experiences</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact CTA Section -->
  <section class="py-20 bg-white">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 class="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">Ready to Get Started?</h2>
      <p class="text-xl text-gray-600 mb-10 leading-relaxed">Whether you're buying, selling, or investing, our team is here to help you achieve your real estate goals.</p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <a href="/properties" class="inline-flex items-center justify-center gap-2 bg-immovea-navy text-white px-8 py-4 rounded-xl hover:bg-blue-900 transition font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
          </svg>
          View All Properties
        </a>
        <a href="/contact" class="inline-flex items-center justify-center gap-2 border-2 border-immovea-navy text-immovea-navy px-8 py-4 rounded-xl hover:bg-immovea-navy hover:text-white transition font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
          Contact Us
        </a>
      </div>
    </div>
  </section>
</div>
